import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

const Publisher = () => (
  <StaticImage alt="List of all the publishers that sponsored elitepvpers" src="../images/publisher.png" width={830} />
)

export default Publisher
